import { SxProps } from "@mui/material";

export const sxHoursTextSent: SxProps = {
  fontFamily: 'Unimed-Sans',
  textTransform: 'none',
  fontSize: '12px',
  lineHeight: '18px'
}

export const sxHoursTextReceived: SxProps = {
  fontFamily: 'Unimed-Sans',
  textTransform: 'none',
  fontSize: '12px',
  lineHeight: '18px',
  alignSelf: 'flex-end',
  color: '#5F5F5F'
}

export const sxMessageText: SxProps = {
  fontFamily: 'Unimed-Sans',
  textTransform: 'none',
  fontSize: '16px',
  lineHeight: '24px',
  color: '#4C4C4C',
}

export const sxFileButton: SxProps = {
  borderRadius: '10px',
  padding: '4px 8px',
  textTransform: 'none',
  textDecoration: 'underline',
  '@media (max-width: 799px)': {
    width: 'stretch',
  },
  backgroundColor: 'white'
}